import { useMemo } from "react"

import { union } from "lodash"

import { useGetAvailableSubnetworkForModule, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_MIRANDA, API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { MIRANDA_GRADE_TYPE, NOTATION_GRADE_TYPE } from "../../../../../common/constants/urlParams"

import { useRelevantMirandaGradings } from "../miranda/useRelevantMirandaGradings"

import { useRelevantNetworkGradings } from "./useRelevantNetworkGradings"

export function useRelevantGradings(config = {}) {

    const { selectedNetwork } = useNetworksStateContext()

    const availableSubNetworksForRoadway = useGetAvailableSubnetworkForModule(API_MODULE_ROADWAY)?.length > 0
    const roadwayAvailable = selectedNetwork.children?.length ? availableSubNetworksForRoadway : selectedNetwork?.modules?.includes(API_MODULE_ROADWAY)
    const { isLoading: isLoadingNetworkGrading, isError: isErrorNetworkGradings, sortedRelevantNetworkGradings } = useRelevantNetworkGradings(selectedNetwork?.slug, {}, { ...config, enabled: roadwayAvailable })

    const availableSubNetworksForMiranda = useGetAvailableSubnetworkForModule(API_MODULE_MIRANDA)?.length > 0
    const mirandaAvailable = selectedNetwork.children?.length ? availableSubNetworksForMiranda : selectedNetwork?.modules?.includes(API_MODULE_MIRANDA)
    const { isLoading: isLoadingMirandaGradings, isError: isErrorMirandaGradings, sortedRelevantMirandaGradings } = useRelevantMirandaGradings(selectedNetwork?.slug, { enabled: mirandaAvailable })

    const isError = isErrorNetworkGradings || isErrorMirandaGradings
    const isLoading = isLoadingNetworkGrading || isLoadingMirandaGradings

    const relevantGradings = useMemo(() => union(
        sortedRelevantNetworkGradings?.map(v => ({ ...v, type: NOTATION_GRADE_TYPE })),
        sortedRelevantMirandaGradings?.map(v => ({ ...v, type: MIRANDA_GRADE_TYPE })),
    ), [sortedRelevantNetworkGradings, sortedRelevantMirandaGradings])

    const sortedRelevantGradings = useMemo(() => {
        if (isLoading) {
            return undefined
        }
        return relevantGradings.filter(grading => {
            return (
                (grading.type === MIRANDA_GRADE_TYPE && mirandaAvailable) || (grading.type === NOTATION_GRADE_TYPE && roadwayAvailable)
            )
        }).reduce((acc, v) => {
            const existingYearIndex = acc.findIndex(item => parseInt(item.year) === parseInt(v.year))

            if (existingYearIndex === -1) {
                acc.push({
                    ...v,
                    type: [v.type],
                })
            } else {
                acc[existingYearIndex].type = Array.isArray(acc[existingYearIndex].type)
                    ? [...acc[existingYearIndex].type, v.type]
                    : [acc[existingYearIndex].type, v.type]
            }
            return acc
        }, [])
            .sort((a, b) => parseInt(a.year) - parseInt(b.year))
    }, [mirandaAvailable, roadwayAvailable, isLoading, relevantGradings])

    return { isLoading, isError, sortedRelevantGradings }
}